const m = window.require("@glimmer/tracking");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;